import { z } from 'zod';

/**
 * Tenant setting `BILLING_AR_FORECAST_SETTINGS` (ALC-1426).
 *
 * `usageForecastLookbackPeriods` is how many most-recent FINALIZED usage
 * service periods feed the arithmetic-mean quantity projection for variable
 * contract items in the Billing AR forecast.
 */
export const BillingArForecastSettingsSchema = z.object({
  usageForecastLookbackPeriods: z.number().int().min(1).max(24),
});

export type BillingArForecastSettings = z.infer<typeof BillingArForecastSettingsSchema>;

export const USAGE_FORECAST_LOOKBACK_MIN = 1;
export const USAGE_FORECAST_LOOKBACK_MAX = 24;
export const USAGE_FORECAST_LOOKBACK_DEFAULT = 3;

/** In-range integer lookbacks pass through; anything else gets the default. */
export function clampUsageForecastLookback(value: unknown): number {
  return typeof value === 'number' &&
    Number.isInteger(value) &&
    value >= USAGE_FORECAST_LOOKBACK_MIN &&
    value <= USAGE_FORECAST_LOOKBACK_MAX
    ? value
    : USAGE_FORECAST_LOOKBACK_DEFAULT;
}

export function getDefaultBillingArForecastSettings(): BillingArForecastSettings {
  return {
    usageForecastLookbackPeriods: USAGE_FORECAST_LOOKBACK_DEFAULT,
  };
}
